import React from "react";
import Partner from "./Partner";
import Documentation from "./Documentation";

const ForPlatforms = () => <div className="for-platforms">
  <Partner/>
  <Documentation/>
</div>;

export default ForPlatforms;